// Generated by Melange


function make(param) {
  return {
    albumIdsByArtistId: new Map(),
    artistInfoById: new Map(),
    byId: new Map(),
    listIds: undefined,
    similarArtistsById: new Map(),
    topSongIdsByArtistName: new Map()
  };
}

export {
  make,
}
/* No side effect */
